import { Action } from 'redux-actions'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import { EditUserPreferences$Request, GetUserPreferences$Request } from '../../../services/api.types'
import {
  cancelUserPreferences,
  editUserPreferences,
  editUserPreferencesFail,
  editUserPreferencesSuccess,
  getUserPreferences,
  getUserPreferencesFail,
  getUserPreferencesSuccess,
} from './NotificationPreferencesActions'
import api from '../../../services/api.services'
import { INotification } from '../../../common/notifications/NotificationReducers'
import { t } from 'ttag'
import { push } from 'connected-react-router'
import { ROUTES } from '../../../common/Routes/routePaths'
import { addNotification, clearNotification } from '../../../common/notifications/NotificationActions'
import { getWhoAmI } from '../../../common/auth/authActions'
import { isNative } from '../../../common/helpers/isNative'
import { askPushNotificationPermissions, setUpPushNotifications } from '../../../services/pushNotifications'

function* sagaGetUserPreferences(action: Action<GetUserPreferences$Request>) {
  yield put({ type: String(clearNotification) })
  try {
    const { preferences } = yield call(api.notifications.getUserPreferences, action.payload)
    yield put({ type: String(getUserPreferencesSuccess), payload: preferences })
    yield put({ type: String(getWhoAmI) })
  } catch (e: any) {
    console.log('GetUserPreferencesFail: ', e)
    yield put({ type: String(getUserPreferencesFail) })
  }
}

function* sagaEditUserPreferences(action: Action<EditUserPreferences$Request & { hasPushNotifications: boolean }>) {
  try {
    yield call(api.notifications.editUserPreferences, action.payload)
    yield put({ type: String(getUserPreferences) })
    yield put({ type: String(editUserPreferencesSuccess) })

    if (action.payload.hasPushNotifications) {
      if (isNative()) {
        try {
          yield askPushNotificationPermissions()
          yield setUpPushNotifications()
        } catch (e: any) {
          console.error('setUpPushNotifications failed: ', e)
        }
      }
    }

    if (action.payload.isDuringRegistration) {
      yield put({ type: String(getWhoAmI) })
    } else {
      const notification: INotification = {
        type: 'success',
        content: t`Notification preferences have been saved!`,
      }
      yield put(push(ROUTES.INBOX.to, { notification }))
    }
  } catch (e: any) {
    console.log('EditUserPreferencesFail: ', e)
    const notification: INotification = {
      type: 'warning',
      content: t`Request failed. Please try again!`,
    }
    yield put({ type: String(addNotification), payload: notification })
    yield put({ type: String(editUserPreferencesFail) })
  }
}

function* sagaCancelUserPreferences() {
  yield put(push(ROUTES.INBOX.to))
}

export function* userPreferencesSagas() {
  yield all([takeEvery(String(getUserPreferences), sagaGetUserPreferences)])
  yield all([takeEvery(String(editUserPreferences), sagaEditUserPreferences)])
  yield all([takeEvery(String(cancelUserPreferences), sagaCancelUserPreferences)])
}
